import {Injectable} from '@angular/core';
import {EmbedService} from "./embed.service";


/**
 * Generic service for working/scrolling with/to html elements.
 */
@Injectable({
  providedIn: 'root'
})
export class ElementService {

  /**
   * The timeout that is used for scrolling to elements to wait for their creation.
   */
  public static readonly SCROLLTIMEOUT = 100;

  /**
   * constructor
   * @param embedService
   */
  constructor(private embedService: EmbedService) {}

  /**
   * Generic function to scroll to a html element with some offset.
   * @param element
   */
  public scrollToTarget(element: HTMLElement): void {
    // add some small timeout in case the element must be shown before.
    setTimeout(() => {
      const offsetPosition = this.getTopOffset(element);

      // only do the scrolling, if the element is not visible.
      if(window.scrollY > offsetPosition || Math.abs(window.scrollY + window.innerHeight) < offsetPosition) {
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, ElementService.SCROLLTIMEOUT);
  }

  /**
   * returns the top offset position of an element.
   * @param element
   * @param headerOffset
   */
  public getTopOffset(element: HTMLElement, headerOffset:number = 50): number {
    if(!element) {
      // avoind race condition where objects are already unset
      return 0;
    }
    const elementPosition = element.getBoundingClientRect().top + window.scrollY;
    return elementPosition - headerOffset;
  }

  /**
   * Scrolls to a given HTML Element.
   * @param element
   */
  public scrollToElement(element: HTMLElement): void {
    if(this.embedService.isEmbedded()) {
      window.setTimeout(() => {
        this.embedService.scrollToTop(this.getTopOffset(element));
      }, ElementService.SCROLLTIMEOUT);
    }
    else {
      this.scrollToTarget(element);
    }
  }
}
